import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVolumeDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="volume-down"><path d="M22.25 12H15.75M1.75 7.75H6L12.25 4.25V19.75L6 16.25H1.75V7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVolumeDown;
